
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { State, namespace } from 'vuex-class'
import siderTrigger from './sider-trigger'
import customBreadCrumb from './custom-bread-crumb'
@Component({
    components: {
        siderTrigger,
        customBreadCrumb
    }
})
export default class HeaderBar extends Vue {
    @State((state) => state.app.breadCrumbList) breadCrumbList
    @Prop(Boolean) readonly collapsed!: boolean | undefined
    @Prop(Array) readonly menuList!: any[]
    name = 'HeaderBar'
    //   change_Name = 1
    @Emit('on-coll-change')
    handleCollpasedChange(state) {
        return state
    }
    //    @Emit('bindSend') send(name: string){}; // send 处理给父组件传值的逻辑
    //   	changeName(name){
    // 	  this.change_Name = name
    // 	  localStorage.setItem('Menu_name', name)
    // 	  this.send(name)
    //   }
}
